<footer>
  <div>
    <img class="power-by " src="./assets/images/folder-power_by.png" />
  </div>
</footer>
